import { reatomAsync, withDataAtom } from "@reatom/async";
import { withAbort } from "@reatom/framework";
import { CalculatePriceRequestDto } from "definitions/poizon-bff";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";

export const getRatePriceRequest = reatomAsync(
  async (ctx, data: CalculatePriceRequestDto) => {
    return await API.subscribeApi
      .subscribeControllerCalculatePrice(data, {
        signal: ctx.controller.signal,
      })
      .then((res) => res.data);
  },
  "getRatePriceRequest",
).pipe(withDataAtom(null), withIsLoadingAtom(), withAbort());
